import Menu from './Menu';
import SubMenu from './SubMenu/SubMenu';
import ShareMenu from './ShareMenu/ShareMenu';
import MenuItem from './MenuItem/MenuItem';
// import MenuItemGroup from './MenuItemGroup';
import Divider from './Divider/Divider';

export { MenuItem as Item, MenuItem, Divider, SubMenu, ShareMenu };

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/index.js